import {Accordion} from './accordion';

const initAccordion = () => {
  const accordion = new Accordion();
  accordion.init();
};

export {initAccordion};
